export function hasPrivilege(inputPrivilege, privileges) {
    if (!privileges) {
        return false
    }
    return !!privileges.find(privilege => privilege === inputPrivilege)
}
